import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { NotificationDto } from '@app/shared/notification-center/notifications.types';
import { UUID } from '@app/_api/identifyable';
import { BaseApi } from '@app/core/services/api/base.api';
import { ToastService } from '@app/core/services/toast.service';
import { DialogService } from '@app/core/services/dialog.service';

@Service()
export class NotificationApi extends BaseApi {
  constructor() {
    const http = inject(HttpClient);
    const toastService = inject(ToastService);
    const dialog = inject(DialogService);

    super(http, '/notification', toastService, dialog);
  }

  fetchAll(): Observable<NotificationDto[]> {
    return this.GET<NotificationDto[]>(`/all`);
  }

  deleteNotification(notificationId: UUID): Observable<void> {
    return this.DELETE<void>(`/${notificationId}`);
  }
}
